import serviceRequestDetailReducer from './service-request-detail.reducers'

export default serviceRequestDetailReducer
